import { render } from "./Udp.vue?vue&type=template&id=3b5fe3d9&lang=pug"
import script from "./Udp.vue?vue&type=script&lang=js"
export * from "./Udp.vue?vue&type=script&lang=js"

import exportComponent from "/home/apognu/code/personal/defcon/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__